import * as React from 'react';
import { Tabs, TabsProps } from '@material-ui/core';

const AppTabs: React.FC<TabsProps> = (props) => (
    <Tabs indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons="auto" {...props} />
);

export default AppTabs;
